import { combineReducers } from "redux";

import availabilitySchedule from "./availabilitySchedule";
import appointments from "./appointments";
import patients from "./patients";
import templates from "./noteTemplates";
import ongoingAppointment from "./ongoingAppointment";
import earningReports from "./earningReports";
import conciergeService from "./conciergeService";

const dashboard = combineReducers({
    availabilitySchedule,
    appointments,
    patients,
    templates,
    ongoingAppointment,
    earningReports,
    conciergeService,
});

export default dashboard;